import { Modal } from 'antd'
import styled from 'styled-components'

export const UnreadDocModalWrapper = styled(Modal)`
  .ant-modal-body {
    background-color: #fbfbfb;
  }
`
